var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0087CF",
    stroke: "#F6F6F6",
    strokeWidth: 1.5,
    d: "M16 1.25h-.002A11.763 11.763 0 0 0 4.25 12.999c0 4.968 2.632 9.269 5.233 12.315 2.61 3.059 5.274 4.953 5.513 5.12a1.753 1.753 0 0 0 2.008 0c.24-.168 2.902-2.061 5.513-5.12 2.6-3.046 5.233-7.347 5.233-12.314v-.001A11.763 11.763 0 0 0 16 1.249Zm0 8.5A3.25 3.25 0 1 1 12.75 13 3.248 3.248 0 0 1 16 9.75Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMarker);
export default __webpack_public_path__ + "static/media/pin-marker.a49b406ae597b62834d3d34cb3c54974.svg";
export { ForwardRef as ReactComponent };